import { useContext } from "react";
import { FormStatus, FormStatusContext } from "./FormStatusProvider";

function useFormStatus(): FormStatus {
  return useContext(FormStatusContext);
}

export default useFormStatus;
